/**
 * ShoppingCartSettingsCtrl controller
 */

/**
 * ShoppingCartSettingsCtrl controller
 *
 * @class ShoppingCartSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:ShoppingCartSettingsCtrl
 */
/* @ngInject */
export default function ShoppingCartSettingsCtrl ($scope, $uibModal, cs, alertLiteSvc) {
  const vm = this

  vm.SC_ENABLED = window.ENV.APP_SC_ENABLED === 'true'

  vm.ngQuillToolbar = {
    toolbar: [
      ['bold', 'underline', 'strike'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: ['', 'center', 'right'] }],
      ['image']
    ]
  }

  vm.cs = cs
  vm.$setType = cs.$setType

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:ShoppingCartSettingsCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return cs._uploadFile(null, file, { type }).data()
  }

  vm.uploadIcon = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width * this.height > 16800000) {
        alertLiteSvc.alertError('Max resolution of image is 16.8MPx')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, `cover_${vm.$setType}_set`)
        .then((url) => {
          vm.cs.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    $scope.form.$setDirty()
  }
}
